import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { REVIEW_RATING } from "@-/dev.improve.haniverse.lib.cards.user-card.fsrs";
import { LearnDeckContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";

/**
 * Rate-as-Easy path for a correctly typed answer: the meaning input box always takes it, the
 * pinyin input box only when `isFastForwardEnabled` is on. Commits {@link REVIEW_RATING.Easy}
 * through the deck — the card parks, saves, and leaves to the right like the Easy button — skipping
 * the reveal entirely.
 */
export function useFastForwardRateAsEasy() {
  const [commit] = useContextSelectors(LearnDeckContext, (c) => c.commit);

  return useMutation({
    mutationFn: async () => {
      commit({ kind: "rate", rating: REVIEW_RATING.Easy }, "fast-forward");
    },
    mutationKey: ["fastForwardRateAsEasy"],
  });
}
